import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { defaultPageSize } from '@synergy/config';

import { SUPPLIER_SPECIAL_OFFERS_DETAIL_PRODUCTS_RECEIVED } from './supplier-special-offers-detail-products-actions';
import { SUPPLIER_SPECIAL_OFFERS_DETAIL_RESET } from '../../store/supplier-special-offers-detail-actions';
import { SpecialOfferProduct } from '../models/special-offer-product';

export interface SupplierSpecialOffersDetailProductsReducerState {
    products: PaginatedResponse<SpecialOfferProduct>;
}

const initialSupplierSpecialOffersDetailsProductsReducerState: SupplierSpecialOffersDetailProductsReducerState = {
    products: { items: [], total: 0, page: 1, limit: defaultPageSize },
};

export const supplierSpecialOffersDetailProductsReducer = (
    state: SupplierSpecialOffersDetailProductsReducerState = initialSupplierSpecialOffersDetailsProductsReducerState,
    action: AnyAction
): SupplierSpecialOffersDetailProductsReducerState => {
    switch (action.type) {
        case SUPPLIER_SPECIAL_OFFERS_DETAIL_RESET: {
            return initialSupplierSpecialOffersDetailsProductsReducerState;
        }

        case SUPPLIER_SPECIAL_OFFERS_DETAIL_PRODUCTS_RECEIVED: {
            return {
                ...state,
                products: action['products'],
            };
        }

        default: {
            return state;
        }
    }
};
